import { saveAs } from "file-saver"
const { apiGetRH, apiPutRH } = require("#api/API_RH")

// import { API } from "#api/API_RH"
const BAJAS = "bajas"
const BAJA_TYPES = `${BAJAS}/types`
const BAJA = (id) => `${BAJAS}/${id}`
const BAJAS_DEPT = (id) => `${BAJAS}/${id}/dept`
const BAJAS_CONTABILIDAD = (id) => `${BAJAS}/${id}/contabilidad`
const CARTA_RENUNCIA = (id) => `${BAJAS}/${id}/carta_renuncia`
const FILES = (id) => `${BAJAS}/${id}/files`

export function apiGetBaja(params = {}) {
	apiGetRH(BAJAS, params)
}

export function apiGetBajaTypes(settings = {}) {
	apiGetRH(BAJA_TYPES, settings)
}

export function bajaPut(id, data, settings = {}) {
	apiPutRH(BAJA(id), data, settings)
}

/**
 *
// <----------- CONTABILIDAD ---------->
* @param {int} id identificador de la baja
* @param {apiGetRhParams} settings
*/
export function bajasContabilidadGet(id, settings = {}) {
	apiGetRH(BAJAS_CONTABILIDAD(id), settings)
}
/**
 *
 * @param {int} id - identificador de la baja
 * @param {any} data - datos a enviar
 * @param {apiPutRhSettingsParams} settings
 */
export function bajasContabilidadPut(id, data, settings = {}) {
	apiPutRH(BAJAS_CONTABILIDAD(id), data, settings)
}
// <------- END CONTABILIDAD ---------->

// <----------- DEPT ---------->
export function bajaDebtsGet(id, settings = {}) {
	apiGetRH(BAJAS_DEPT(id), settings)
}

export function bajasDeptPut(id, data, settings) {
	apiPutRH(BAJAS_DEPT(id), data, {
		...settings,
		message: { success: "Adeudos subidos con éxito" },
	})
}
//<----------- END DEPT ---------->

/**
 *
 * @param {int} id - identificador de la baja
 * @param {apiGetRhParams} settings
 */
export function bajaFilesGet(id, settings = {}) {
	apiGetRH(FILES(id), settings)
}
/**
 *
 * @param {int} id - identificador de la baja
 * @param {any} data - datos a enviar
 * @param {apiPutRhSettingsParams} settings
 */
export function bajaFilesPut(id, data, settings = {}) {
	apiPutRH(FILES(id), data, settings)
}

export function bajaCartaRenunciaGet(id) {
	const success = (data) => {
		saveAs(data.data, `carta_renuncia.pdf`)
	}
	apiGetRH(CARTA_RENUNCIA(id), {
		success,
		all: true,
		axiosProps: { responseType: "blob" },
	})
}
